import { Box, styled } from '@mui/material';

export const StyledTimesBox = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;
